<div class="recommended">
    <div class="container-title">
        <h1 class="section-title">{{ 'shoppingCart.recommendedProducts' | translate }}</h1>
    </div>
    <drag-scroll class="card-list hiddenScroll" style="min-height: 413px; height: max-content" drag-scroll-y-disabled="true">
        <div class="card product-recommended" *ngFor="let product of recommended; let i = index;">
            <div class="sold-out centered" *ngIf="product.availableItems === 0">
                <span>{{ 'home.soldOut' | translate}}</span>
            </div>
            <mat-icon
                (click)="toggleFavorite(product?.id)"
                fontSet="material-icons-round" class="favorite-icon"
                [ngClass]="{'favorited': product?.isFavorite }">
                    {{ product?.isFavorite ? 'favorite' : 'favorite_border' }}
            </mat-icon>
            <div (click)="goToDetails(product?.id)" class="product-image" [style.background-image]="'url(' + getProductImage(product.midias) + ')'">
                <img [src]="product?.waterMark" alt="watermark" class="watermark" *ngIf="product?.waterMark">
            </div>
            <div class="product-info">
                <p class="product-name">{{ product?.name }}</p>
                <div class="available-item">
                    <div style="display: flex;" *ngIf="!isAdvertisement(product) || (isAdvertisement(product) && !hideAdvertisementPrice)">
                        <p class="price">{{ product?.price | currency:'BRL':true:'1.2-2'}}</p>
                        <p class="old-price" *ngIf="product.oldPrice && product.discount">{{ product?.oldPrice | currency:'BRL':true:'1.2-2'}}</p>
                    </div>

                    <div style="display: flex;" *ngIf="isAdvertisement(product) && hideAdvertisementPrice">
                        <p class="price">{{ 'productDetails.knowMore' | translate }}</p>
                    </div>

                    <div class="bottom-container">
                        <div class="free-shipping" *ngIf="product.freeShipping">
                            <mat-icon fontSet="material-icons-round">local_shipping</mat-icon>
                            <span>{{ 'home.freeShipping' | translate }}</span>
                        </div>
                        <div class="discount" *ngIf="product.oldPrice && product.discount && (!isAdvertisement(product) || (isAdvertisement(product) && !hideAdvertisementPrice))">
                            <strong>-{{ product?.discount | currency:'BRL':true:'1.2-2'}}</strong>
                        </div>
                    </div>
                </div>
                <div class="unavailable-item" *ngIf="product.availableItems === 0">
                    <p>{{ 'home.unavailableItem' | translate}}</p>
                </div>
            </div>
        </div>
    </drag-scroll>
</div>
